module.exports = __webpack_public_path__ + "img/9-4.a931190d.jpg";